import * as React from "react"
const CallIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      stroke="#007AC1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 13.48v2.408a1.604 1.604 0 0 1-1.094 1.527 1.613 1.613 0 0 1-.66.079 15.94 15.94 0 0 1-6.943-2.465 15.672 15.672 0 0 1-4.827-4.818 15.868 15.868 0 0 1-2.47-6.96 1.603 1.603 0 0 1 .953-1.614c.204-.09.425-.137.648-.137h2.414A1.61 1.61 0 0 1 6.63 2.881c.102.77.29 1.528.563 2.256a1.603 1.603 0 0 1-.362 1.694l-1.022 1.02a12.86 12.86 0 0 0 4.827 4.817l1.022-1.02a1.61 1.61 0 0 1 1.697-.36c.73.271 1.489.46 2.26.561A1.61 1.61 0 0 1 17 13.48Z"
    />
  </svg>
)
export default CallIcon